import { getConfig } from './config';

export const getApiBaseUrl = (): string => getConfig().apiBaseUrl;

export const API_ENDPOINTS = {
  CLIENTS: '/clients',
  CLIENT_BY_ID: (id: string) => `/clients/${id}`,

  DEVICES: '/devices',
  DEVICE_BY_ID: (id: string) => `/devices/${id}`,
  DEVICES_UNLINKED: '/devices/unlinked',

  USERS: '/users',
  USER_BY_ID: (id: string) => `/users/${id}`,

  GROUPS: '/groups',
  GROUP_BY_ID: (id: string) => `/groups/${id}`,

  PERMISSIONS: '/permissions',

  ALERTS: '/alerts',
  ALERTS_SUMMARY: '/alerts/summary',

  DASHBOARD_OVERVIEW: '/dashboard/overview',

  INVENTORY: '/inventory',

  LOGIN: '/local-auth/login',
  REFRESH: '/local-auth/refresh',
  LOGOUT: '/local-auth/logout',
  PROFILE: '/local-auth/me',
  VALIDATE_TOKEN: '/local-auth/me',
} as const;
